module.exports = __webpack_public_path__ + "img/coins.341aa85.png";